export default {

  cookiesAccepted(state) {
    return state.cookiesAccepted;
  },
  viewsinglereport(state) {
    return state.viewsinglereport;
  },
  academyUrl(state) {
    return state.academyUrl;
  },
  companyUrl(state) {
    return state.companyUrl;
  },
  facebookUrl(state) {
    return state.facebookUrl;
  },
  instagramUrl(state) {
    return state.instagramUrl;
  },
  linkedinUrl(state) {
    return state.linkedinUrl;
  },
  twitterUrl(state) {
    return state.twitterUrl;
  },
  mapUrl(state) {
    return state.mapUrl
  },
  activeSelectedStudy(state){
    return state.activeSelectedStudy
  }
};
